import { useUserDetails } from 'user-data/hooks/useUserDetails'

import { useMyAccount } from '../contexts/MyAccountProvider'
import {
	getQuestionsWithInactiveOrders,
	getQuestionsWithoutInactiveOrders,
} from '../utils/getQuestions/getQuestions'

export function useQuestionsIds() {
	const {
		userInfo: { inactivePurchases },
	} = useMyAccount()
	const userDetails = useUserDetails()
	if (!userDetails) {
		return null
	}
	const { loyalty, birthDate } = userDetails

	if (!loyalty) {
		return null
	}
	const { isLoyalty, likes } = loyalty

	if (!inactivePurchases.length) {
		return getQuestionsWithoutInactiveOrders({
			isLoyalty,
			birthDate,
			likes: likes?.available,
		})
	} else {
		return getQuestionsWithInactiveOrders({
			isLoyalty,
			birthDate,
			likes: likes?.available,
		})
	}
}
